import { LitElement, html, css } from 'lit-element';
import { styleMap } from 'lit-html/directives/style-map.js';
import dayjs from 'dayjs';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import '@trumedianetworks/tmn-core-components/src/tmn-switch';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import { actions, selectors } from './';
import { connect } from '../store/connect';
import { selectors as userSelectors } from '../user';
import { selectors as accountSelectors } from '../account';
import { SELECT_MODES } from '../table/table-constants';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
import '../routing/routed-link';
import '../table/tmn-table-searchable';
import { CustomFilterDef } from '../table/filter-definition';
const { CAN_EDIT_ROOT_SITES } = AUTHORIZATIONS;

const dateFormatFn = (value, row) => {
    return value
        ? html`${dayjs(value).format('YYYY-MM-DD')}`
        : html`<div style="text-align:center">-</div>`;
};

// true means include this row. This filter removes staging sites (in a crude manner)
const stagingFilter = (row) => {
    if (row?.name) {
        return !row?.name?.includes('-staging');
    }
    return true;
};

const stagingFilterDef = new CustomFilterDef({ filterFn: stagingFilter });

const EMPTY_ARRAY = [];
class AdminContextSearch extends LitElement {
    constructor() {
        super();
        this.availableAuthSites = [];
        this._columnDefs = [];
    }

    static get styles() {
        // can be shared with site or more general table component maybe?
        return [
            css`
                tmn-switch {
                    white-space: nowrap;
                }
                .search-all-container {
                    font-size: 15px;
                    font-weight: 600;
                    display: flex;
                    flex: 1;
                    /* justify-content: flex-end;
                    max-width: 1200px; */
                }
                h2 {
                    margin-block-start: 0.4em !important;
                    margin-block-end: 0.4em;
                }
            `,
        ];
    }

    static get properties() {
        return {
            availableAuthSites: {
                type: Array,
            },
            activeAuthSite: {
                type: String,
            },
            _columnDefs: {
                type: Array,
            },
            // todo make this more general purpose filters
            showStaging: {
                type: Boolean,
            },
            authorizations: {
                type: Array,
            },
        };
    }

    updated(changedProps) {
        if (changedProps.has('availableAuthSites')) {
            //const { activeAuthSite } = this;
            // probably need to make name click an event and/or just use row select
            this._columnDefs = [
                {
                    label: 'Name',
                    key: 'name',
                    sortable: true,
                    search: true,
                    dataFormatter: (name, row) => {
                        const id = row.metaData.id;
                        const data = { authSite: name };
                        return html`<routed-link .data=${data} name="user-list"
                            >${name}</routed-link
                        >`;
                    },
                },
                {
                    key: 'sport',
                    label: 'Sport',
                    sortable: true,
                    search: true,
                },
                // {
                //     key: 'emailAccountDomain',
                //     label: 'Email Domain',
                //     sortable: true,
                //     search: true,
                // },
                {
                    key: 'updated',
                    label: 'Updated',
                    sortable: true,
                    dataFormatter: dateFormatFn,
                },
                {
                    key: 'active',
                    label: 'Active',
                    sortable: true,
                    dataFormatter: (value, row) => {
                        // todo sort out formatter options/styles, maybe do like tmn-table-render
                        // but see if there is a better technique now
                        const iconStyle = styleMap({
                            color: value ? 'var(--app-primary-color)' : 'rgba(0, 0, 0, 0.1)',
                            textAlign: 'center',
                        });

                        return value
                            ? html`<div style=${iconStyle}>
                                  <tmn-icon
                                      icon="check_circle_outline"
                                      iconvariant="outlined"></tmn-icon>
                              </div>`
                            : html`<div style=${iconStyle}>
                                  <tmn-icon icon="circle" iconvariant="outlined"></tmn-icon>
                              </div>`;
                    },
                },
            ];
        }
    }

    render() {
        const { availableAuthSites, _columnDefs, selectedUsersIds, showStaging } = this;
        const selectMode = SELECT_MODES.NONE;
        const filterDefs = this.getFilters();
        return html`<h2>Select an authorization site</h2>
            ${this.renderSearchAllOption()}
            <tmn-table-searchable
                @tmn-row-select-toggle=${this.handleRowSelectToggle}
                .rowIdentifier=${'eSiteId'}
                .dataRows=${availableAuthSites}
                .selectedRowIds=${selectedUsersIds}
                .selectMode=${selectMode}
                .columnDefs=${_columnDefs}
                .filterDefs=${filterDefs}>
                <div slot="right-actions">
                    <tmn-switch
                        .checked=${showStaging}
                        color="primary"
                        @tmn-switch-change=${this.toggleShowStaging}>
                        Show Staging
                    </tmn-switch>
                </div>
            </tmn-table-searchable> `;
    }
    renderSearchAllOption() {
        const { authorizations } = this;
        if (authorizations.includes(CAN_EDIT_ROOT_SITES)) {
            return html`<div class="search-all-container">
                <routed-link name="user-search-all">Search users across all sites</routed-link>
            </div>`;
        }
    }

    getFilters() {
        return this.showStaging ? EMPTY_ARRAY : [stagingFilterDef];
    }

    toggleShowStaging(e) {
        // todo eventually do better filters based on columns from table
        const showStaging = !this.showStaging;
        this.actions.setAvailableAuthSiteFilters({
            showStaging,
        });
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const availableAuthSites = selectors.availableAuthSitesSelector(state);
        const activeAuthSite = userSelectors.activeAuthSiteNameSelector(state);
        const authSiteFilters = selectors.availableAuthSitesFiltersSelector(state);
        return {
            availableAuthSites,
            activeAuthSite,
            showStaging: !!authSiteFilters.showStaging,
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
        };
    };
};

customElements.define(
    'admin-context-search',
    connect(mapStateToProps, actions)(AdminContextSearch)
);
